import { render, staticRenderFns } from "./TabletListItem.vue?vue&type=template&id=cbed043e&scoped=true&lang=pug"
import script from "./TabletListItem.vue?vue&type=script&lang=ts"
export * from "./TabletListItem.vue?vue&type=script&lang=ts"
import style0 from "./TabletListItem.vue?vue&type=style&index=0&id=cbed043e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbed043e",
  null
  
)

export default component.exports